<app-admin-appbar></app-admin-appbar>
<br />

<div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
  <div class="d-flex flex-column">
    <label
      class="form-label small text-muted mb-1"
      for="admin_users_filter_status"
    >
      Status
    </label>
    <kendo-dropdownlist
      id="admin_users_filter_status"
      [defaultItem]="{ text: 'All', value: null }"
      textField="text"
      valueField="value"
      [data]="statuses"
      [style]="{ width: '200px' }"
      (valueChange)="statusChange($event)"
    ></kendo-dropdownlist>
  </div>
  <button
    kendoButton
    class="align-self-end"
    (click)="addUser()"
    [svgIcon]="plusIcon"
    themeColor="primary"
  >
    Add User
  </button>
</div>

<app-datatable
  [data-href]="datatableUrl"
  [columns]="datatableColumns"
  [useOData]="true"
  [initialFilters]="initialFilters"
  [clickableRows]="true"
  (rowClick)="editUser($event)"
></app-datatable>
